export const stagingURL = 'https://api.staging.paylater.ng/'
export const productionURL = 'https://api.getcarbon.co/'
